import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  // Labels share one line, so cells align to the top. A row that holds a 40px
  // control (the delay input or the reason select) centers its text values and
  // its switch on that control's height, so every value reads on one line too.
  messageRowContainer: {
    display: 'flex',
    flexFlow: 'row',
    alignItems: 'flex-start',
    gap: theme.spacing(2),
    paddingBottom: theme.spacing(1),
    borderBottom: theme.customBorders.gray200,
  },
  withControls: {
    '& $valueBox': {
      minHeight: theme.spacing(5),
    },
    '& $disableSwitchContainer .MuiSwitch-root': {
      marginTop: theme.spacing(1.5),
      marginBottom: theme.spacing(1.5),
    },
    '& $actionsCell': {
      marginTop: theme.spacing(3),
    },
  },
  valueBox: {
    display: 'flex',
    alignItems: 'center',
    minWidth: 0,
  },
  // The widths fit the design's English labels. A longer translated label
  // widens its cell instead of wrapping, which would push the cell's control
  // below the rest of the row.
  sendWhenCell: {
    width: theme.spacing(23.75), // 190px
    minWidth: 'min-content',
    flexShrink: 0,
  },
  rejectionReasonCell: {
    width: theme.spacing(22.5), // 180px
    minWidth: 'min-content',
    flexShrink: 0,
  },
  messageTitleCell: {
    flex: 1,
    minWidth: 0,
  },
  deliveryMethodCell: {
    width: theme.spacing(15), // 120px
    minWidth: 'min-content',
    flexShrink: 0,
  },
  delayCell: {
    width: theme.spacing(12), // 96px
    minWidth: 'min-content',
    flexShrink: 0,
  },
  disableCell: {
    flexShrink: 0,
  },
  // Centers the 32px buttons on the 16px value line below a 20px label.
  actionsCell: {
    marginLeft: 'auto',
    marginTop: theme.spacing(1.5),
    display: 'flex',
    alignItems: 'center',
  },
  actionsCellContent: {
    display: 'flex',
  },
  cellHeader: {
    display: 'block',
    marginBottom: theme.spacing(0.5),
    color: theme.palette.common.gray600,
    whiteSpace: 'nowrap',

    '&.required': {
      '&:after': {
        content: "' *'",
        color: theme.palette.common.red400,
      },
    },
  },
  // The design sets the label of the reason select in the value color.
  reasonHeader: {
    color: theme.palette.common.gray800,
  },
  cellContent: {
    color: theme.palette.common.gray800,
  },
  messageTitleContent: {
    minWidth: 0,
    color: theme.palette.common.gray800,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  // The buttons keep their 32px hit area; with no margin between them the
  // 16px glyphs sit 16px apart.
  editMessageButton: {
    height: theme.spacing(4),
    width: theme.spacing(4),
  },
  deleteMessageButton: {
    height: theme.spacing(4),
    width: theme.spacing(4),
  },
  editMessageIcon: {
    width: theme.spacing(2),
    height: theme.spacing(2),
    '& path': {
      fill: theme.palette.common.gray600,
    },
  },
  deleteMessageIcon: {
    width: theme.spacing(2),
    height: theme.spacing(2),
    '& path': {
      fill: theme.palette.common.gray600,
    },
  },
  disableSwitchContainer: {
    flexDirection: 'column-reverse',
    alignItems: 'center',
    margin: 0,
  },
  linkedTemplate: {
    borderRadius: theme.spacing(0.75),
    marginRight: theme.spacing(1),
    '& svg': {
      marginRight: theme.spacing(1),
    },
  },
}));
